/**
 * AppLogo Component
 * Displays app name and optional logo on the left side of the header
 */

import React from 'react';
import { AppLogoProps } from './types';
import styles from './AppHeader.module.css';

/**
 * Renders the application name and optional logo
 * Positioned on the left side of the header
 * Semantic: Uses h1 for main heading
 */
export const AppLogo: React.FC<AppLogoProps> = ({ appName, logoUrl }) => {
  return (
    <div className={styles.appLogo} data-testid="app-logo">
      {logoUrl && (
        <img
          src={logoUrl}
          alt=""
          aria-hidden="true"
          className={styles.logoImage}
          data-testid="app-logo-image"
        />
      )}
      <h1 className={styles.appName} data-testid="app-name">
        {appName}
      </h1>
    </div>
  );
};

export default AppLogo;
